module.exports = __webpack_public_path__ + "static/media/Labelizer_Image.329d6070.png";